import {IAction, ActionType} from '../Actions';

export const startup = (): IAction<null> => ({
  type: ActionType.STARTUP,
  payload: null,
});
